import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=314b6a58"
import script from "./auth.vue?vue&type=script&lang=ts"
export * from "./auth.vue?vue&type=script&lang=ts"
import style0 from "./auth.vue?vue&type=style&index=0&id=314b6a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports